<template>
  <div class="novo-img">
    <div
      class="img-box"
      ref="imgBoxRef"
      @click="imgClick"
      :style="{
        width:(wWidth||imgW)+'px',
        height:(wHeight||imgH)+'px',
        overflow:(type=='center'||'cover')?'hidden':'auto',
        backgroundColor:backgroundColor
      }"
    >
      <img
        :id="imgId"
        :src="getSrc()"
        alt=""
        :style="{width:imgW,height:imgH,position:((type==='center')||(type ==='cover'))?'absolute':'auto'}"
      >
    </div>
  </div>
</template>
<script>
import { clientDetail, getScrollBarSize } from "utils";
// import { getById, clientDetail } from "utils";
export default {
  /**
   * @name: NovoImg
   * @desc: 图片组件
   * @author: 刘毅豪(liuyihao@krspace.cn)
   * @props {Number, String} height 图片的高如果isPage为true的话height是窗口高，如果height不传并且isPage为false时则height高为图片高
   * @props {Number, String} width 图片的宽如果isPage为true的话width是窗口宽，如果width不传并且isPage为false时则width为图片宽
   * @props {Boolean} isPage 如果为true时图片的宽高是窗口宽高除去滚动条
   * @props {String} src 图片的途径
   * @props {String} type 图片的展示形式一共三个值【auto（自动展示）,center（拉伸截取展示）,cover（全部展示）】
   * @props {String} backgroundColor 图片展示时的背景色
   * @emit: click 图片点击事件 event
   */
  props: {
    height: {
      type: [Number, String]
    },
    width: {
      type: [Number, String]
    },
    isPage: {
      type: Boolean,
      default: false
    },
    src: {
      type: String
    },
    type: {
      type: String, //auto,center,cover
      default: "auto"
    },
    backgroundColor: {
      default: "transparent",
      type: String
    },
    isLazy: {
      default: false,
      type: Boolean
    },
    dis:{
      type:Number,
      default:20
    }
  },
  data() {
    return {
      isLoading: false,
      isReachBottom: false,
      imgW: "auto",
      imgH: "auto",
      imgId: "img" + this._uid,
      imgLeft: "auto",
      imgTop: "auto",
      imgMarginLeft: "auto",
      imgMarginTop: "auto",
      wHeight: this.height,
      wWidth: this.width,
      isRenderUrl:false
    };
  },
  watch: {
    src() {
      let imgDom = document.getElementById(this.imgId);
      let that = this;

      imgDom.onload = function() {
        that.setimgSize(that.type, imgDom);
      };
    }
  },
  mounted() {
    let boxDom = this.$refs["imgBoxRef"];
    if (this.isPage) {
      this.setPage();
    }
    let that = this;
    let imgDom = document.getElementById(this.imgId);
    imgDom.onload = function() {
      that.setimgSize(that.type, imgDom);
    };


    if (this.isPage) {
      window.addEventListener("resize", () => {
        this.setPage();
        that.setimgSize(that.type, imgDom);
      });
    }

    if (this.isLazy) {
      const dis = this.dis;
      const height = clientDetail().h;
      document.addEventListener("scroll", ()=>{
        this.scroll(boxDom, dis, document, height);
      }, false);
    }
  },
  //解除绑定
  beforeDestroy() {
    window.removeEventListener("resize", this.setPage);
    document.removeEventListener("scroll", this.scroll, false);
  },
  
  methods: {
    getSrc(){
      if(this.isLazy && !this.isRenderUrl){
        return ''
      }else{
        return this.src;
      }
    },
    scroll(dom, dis, scrollWrap, height) {
      const lazyDetail = dom.getBoundingClientRect();
    
      if (lazyDetail.top - height + dis <= 0) {
       
        this.isRenderUrl = true;
        scrollWrap.removeEventListener("scroll", this.scroll);
      }
    },
    imgClick(event) {
      this.$emit("click", event);
    },
    setPage() {
      const winDetail = clientDetail();
      const barSize = getScrollBarSize();
      this.wHeight = winDetail.h;
      this.wWidth = winDetail.w - barSize;
    },
    setimgSize(type, dom) {
      let imgDetail = dom.getBoundingClientRect();
      let w = imgDetail.width;
      let h = imgDetail.height;

      if (type == "auto") {
        this.imgW = this.wWidth + "px" || "auto";
        this.imgH = this.wHeight + "px" || "auto";
        return;
      }

      if (type == "center") {
        let newW = (w / h) * this.wHeight; //height 100%时
        let newH = (h / w) * this.wWidth;

        if (newW <= this.wWidth) {
          this.imgW = newW + "px";
          this.imgH = this.wHeight + "px;";
          dom.style.left = "50%";
          dom.style.top = 0;
          dom.style.marginLeft = -newW / 2 + "px";
          dom.style.marginTop = -0 + "px";
        } else {
          this.imgW = this.wWidth + "px";
          this.imgH = newH + "px;";
          dom.style.top = "50%";
          dom.style.left = 0;
          dom.style.marginTop = -newH / 2 + "px";
          dom.style.marginLeft = 0 + "px";
        }
      }
      if (type == "cover") {
        let newW = (w / h) * this.wHeight; //height 100%时
        let newH = (h / w) * this.wWidth;
        if (newW <= this.wWidth) {
          this.imgW = this.wWidth + "px";
          this.imgH = newH + "px;";
          dom.style.top = "50%";
          dom.style.left = 0 + "px";
          dom.style.marginTop = -newH / 2 + "px";
          dom.style.marginLeft = 0 + "px";
        } else {
          this.imgW = newW + "px";
          this.imgH = this.wHeight + "px;";
          dom.style.left = "50%";
          dom.style.top = 0 + "px";
          dom.style.marginLeft = -newW / 2 + "px";
          dom.style.marginTop = 0 + "px";
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.novo-img {
  .img-box {
    display: inline-block;
    text-align: center;
    position: relative;
    // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/novo-img/index.vue